__turbopack_context__.v({
  "container": "index-module__5dZQsW__container",
  "contentWrapper": "index-module__5dZQsW__contentWrapper",
  "section": "index-module__5dZQsW__section",
});
